<div [ngClass]="{'menuDropdown-elem': true, 'menuDropdown-active': router.url === '/' + elemento.path, 'menuDropdown-on': expanded}"
    (mouseenter)="expanded = true" (mouseleave)="expanded = false">
    <a
       
        [ngClass]="(elemento?.clase && elemento.clase != '') ? 'menuDropdown-link ' + elemento.clase : 'menuDropdown-link' "

        title=""
        (click)="seleccionItemMenu(elemento)"
        [rel]="(elemento?.url=='#') ? 'nofollow': ''"
        [target]="(elemento?.target && elemento.target != '') ? elemento.target: ''">

        <span>{{elemento?.nombre}}</span>

        <ng-container *ngIf="elemento?.hijos && elemento.hijos.length > 0">
            <i class="menuDropdown-sub icon-24 icon-mdi--arrow_drop_down" [@indicatorRotate]="expanded ? 'expanded': 'collapsed'"></i>
        </ng-container>
    </a>

    <ng-container *ngIf="elemento?.hijos && elemento.hijos.length > 0">
        <neo-menu-dropdown-nav #menuDropdownNav
        *ngIf="expanded" [@enterAnimation]
        [principal]="false"
        [elementos]="elemento.hijos"
        ></neo-menu-dropdown-nav>
    </ng-container>

</div>
